<template>
    <div class="card">
        <div class="card-body">
            <h3>{{$t('common.travelers.travelers')}}</h3>
            <div
                v-for="traveler in trip.pnr.travelers"
                :key="traveler.id"
                class="mt-3 row"
            >

                <div class="col">
                    <h4 class="text-dark">{{traveler.fullName}}</h4>
                </div>
                <div v-if="showPricing" class="col-auto">
                    <h4 class="text-end">{{$filters.beautifyCurrency(traveler.price)}}</h4>
                </div>
                <div v-if="traveler.ticketNumbers.length > 0 || traveler.fqtvs.length > 0" class="col-12">
                    <div class="row details">
                        <div v-if="traveler.ticketNumbers.length > 0" class="col-lg-auto">
                            <div class="row">
                                <div class="col-auto py-1">
                                    <font-awesome-icon :icon="['fal', traveler.ticketNumbers.length > 1 ? 'tickets-airline' : 'ticket-airline']" fixed-width class="fa-lg text-secondary me-2 "/>
                                    <!--TODO Pluralize -->
                                   {{$tc('common.travelers.ticketNumber', traveler.ticketNumbers.length)}}
                                </div>
                                <div class="col-auto py-1">
                                    <strong>{{traveler.ticketNumbers.join(', ')}}</strong>
                                </div>
                            </div>
                        </div>
                        <div v-if="traveler.fqtvs.length > 0" class="d-none d-lg-block col-auto py-1">
                            <strong>&bull;</strong>
                        </div>
                        <div v-if="traveler.fqtvs.length > 0" class="col-lg-auto">
                            <div class="row">
                                <div class="col-auto py-1">
                                    <font-awesome-icon :icon="['fal', 'id-card']" fixed-width class="fa-lg text-secondary me-2"/>
                                    <!--TODO Pluralize -->
                                    {{$tc('common.travelers.frequentTravelerNumber', traveler.fqtvs.length)}}
                                </div>
                                <div class="col-auto py-1">
                                    <strong>{{traveler.fqtvs.join(', ')}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showPricing">
                <branded-divider class="mt-3" />
                <div class="row mt-3">
                    <div class="col">
                        <h4 class="text-dark">{{$t('common.travelers.totalPrice')}}</h4>
                    </div>
                    <div class="col-auto">
                        <h4 class="text-end">{{$filters.beautifyCurrency(trip.pnr.totalPrice)}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BrandedDivider from "@/components/common/BrandedDivider";
export default {
    name: 'Travelers',
    components: {
        BrandedDivider
    },
    props: {
        trip: {
            type: Object,
            required: true
        },
        showPricing: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
@include media-breakpoint-down(sm) {
    //Reduce font size on sm & xs screens.
    h4 {
        font-size: 1.15rem;
    }
    .details {
        font-size: 0.85rem;
    }
}
</style>